import React from 'react';
import { BundleDetailTemplate } from './BundleDetailTemplate';

export const BundleCulture = () => <BundleDetailTemplate slug="culture-dei-engagement" />;
